export default __webpack_public_path__ + "static/media/powerbi.6b696972.svg";